import { proxy } from 'valtio'
import { derive, devtools } from 'valtio/utils'
import { type ApiCallType } from '../../../shared/types/ApiCallType'
import { resetProxy } from '../../../shared/utils/proxyUtils'
import { FormFieldNamesEnum } from './components/RequestPasswordResetForm/formFieldNamesEnum'
import { FIELDS_REQUIRED_FOR_SUBMISSION } from './components/RequestPasswordResetForm/validators'

interface ProxyRequestPwResetType {
  allowSubmit: boolean
  apiCallRequestPasswordReset: ApiCallType
  formValues: { [key in FormFieldNamesEnum]?: string | null }
  formErrors: { [key in FormFieldNamesEnum]?: string | null }
  formDirtied: readonly FormFieldNamesEnum[]
  formBlurred: readonly FormFieldNamesEnum[]
  showEmailError: boolean
}

const initialValues = {
  apiCallRequestPasswordReset: {
    error: null,
    loading: false
  },
  formBlurred: [],
  formDirtied: [],
  formErrors: {},
  formValues: {}
}

const baseProxy = proxy(initialValues)

const showErrorFunctionGenerator = (fieldName: FormFieldNamesEnum) => (get: any) => {
  const { formDirtied, formBlurred, formErrors } = get(baseProxy)
  const isDirty = (formDirtied as string[]).includes(fieldName)
  const isBlurred = (formBlurred as string[]).includes(fieldName)
  const isErrored = Boolean((formErrors as { [key in FormFieldNamesEnum]?: string | null })[fieldName])
  return isDirty && isBlurred && isErrored
}

export const proxyRequestPasswordReset = derive({
  allowSubmit: (get) => {
    const { apiCallRequestPasswordReset: { loading }, formDirtied, formErrors } = get(baseProxy)
    const noErrors = Object.values(formErrors).filter(x => x).length === 0
    // @ts-expect-error
    const allDirtied = FIELDS_REQUIRED_FOR_SUBMISSION.every((x: string) => formDirtied.includes(x))
    return noErrors && allDirtied && !loading
  },
  showEmailError: showErrorFunctionGenerator(FormFieldNamesEnum.Email)
}, { proxy: baseProxy }) as ProxyRequestPwResetType

devtools(proxyRequestPasswordReset, { name: 'proxyRequestPwReset' })

export function resetProxyRequestPasswordReset (): void {
  resetProxy(initialValues, proxyRequestPasswordReset)
}
